import API from '@aws-amplify/api';
import config from '../config';

API.configure(config.aws);

export default API;